import { MdWarning } from 'react-icons/md/index';
import Modal from '~/components/feedback/Modal';

const ReceiptExampleModal: React.FC = () => {
	return (
		<Modal>
			<h1 className="font-subheading text-center">Receipt upload guide</h1>
			<div className="text-sm border-current border-2 rounded-md flex flex-row items-center space-x-4 p-3">
				<MdWarning size={40} className="warning-icon text-2xl" />
				<div>
					<p className="font-bold">Maximum file size: 2MB each.</p>
					<p>File types accepted - PDF, JPG, JPEG or PNG only.</p>
				</div>
			</div>
			<img
				src="https://res.cloudinary.com/kollwitzowen/image/upload/v1669674653/mix%20agency/trident/Sriracha_Phsyical_Receipt_2x_z1l39x.jpg"
				alt=""
				width={200}
				className="mx-auto mb-6"
			/>
			<p className="text-sm">
				Ensure the receipt is in good condition, not damaged or in pieces. Images should be
				clear and in focus, not obscured by any objects. If the purchase receipt is missing
				any of the above information, or is illegible or indecipherable, it will render the
				entry invalid. If the same receipt is submitted multiple times, the Promoter will
				render all entries using that one receipt invalid.
			</p>
		</Modal>
	);
};

export default ReceiptExampleModal;
